(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-image-with-text-overlay"] && !Shopify.designMode) return;
  try {
    const openCustomLooxReviews = () => {
    if (window.LOOX && typeof window.LOOX.openHCFloater === "function") {
      window.LOOX.openHCFloater()
      return true
    }

    const looxTrigger = document.querySelector(
      '.loox-trust-badge-container[data-loox-open-reviews="true"] .loox-trust-badge-widget-content-container'
    )

    if (looxTrigger) {
      looxTrigger.click()
      return true
    }

    return false
  }

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-custom-loox-trigger]")
    if (!trigger) return

    if (openCustomLooxReviews()) return
    if (trigger.dataset.looxOpening === "true") return

    trigger.dataset.looxOpening = "true"
    let attempts = 0
    const waitForLoox = window.setInterval(() => {
      attempts += 1

      if (openCustomLooxReviews()) {
        window.clearInterval(waitForLoox)
        delete trigger.dataset.looxOpening
        return
      }

      if (attempts < 20) return

      window.clearInterval(waitForLoox)
      delete trigger.dataset.looxOpening
      if (trigger.dataset.fallbackUrl) window.location.assign(trigger.dataset.fallbackUrl)
    }, 100)
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-ships-by"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shipping-estimate')) {
    customElements.define('shipping-estimate', class extends HTMLElement {
      connectedCallback() {
        this.refreshDate();
        this.refreshTimer = window.setInterval(() => this.refreshDate(), 60000);
      }
      disconnectedCallback() {
        window.clearInterval(this.refreshTimer);
      }
      refreshDate() {
        const time = this.querySelector('time');
        if (!time) return;
        const remainingDays = Number(this.dataset.businessDays);
        if (!Number.isInteger(remainingDays) || remainingDays < 0 || remainingDays > 14) return;
        const excluded = new Set((this.dataset.excludedDates || '').split(/\r?\n/).map(value => value.trim()));
        const isoDate = date => [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('-');
        const isWorkingDay = date => !(this.dataset.skipWeekends === 'true' && [0, 6].includes(date.getDay())) && !excluded.has(isoDate(date));
        const date = new Date();
        date.setHours(12, 0, 0, 0);
        let remaining = remainingDays;
        let iterations = 0;
        while ((remaining > 0 || !isWorkingDay(date)) && iterations < 120) {
          date.setDate(date.getDate() + 1);
          if (isWorkingDay(date) && remaining > 0) remaining--;
          iterations++;
        }
        if (remaining > 0 || !isWorkingDay(date)) return;
        const format = this.dataset.dateFormat;
        const parts = new Intl.DateTimeFormat('en-US', {
          weekday: format === 'long' ? 'long' : 'short',
          month: format === 'long' ? 'long' : 'short',
          day: 'numeric'
        }).formatToParts(date);
        const part = type => parts.find(value => value.type === type).value;
        time.dateTime = isoDate(date);
        time.textContent = format === 'day_month'
          ? `${part('weekday')}, ${part('day')} ${part('month')}`
          : `${part('weekday')}, ${part('month')} ${part('day')}`;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
